module.exports = __webpack_public_path__ + "media/images/pc/top/soudan_comment_02@3x-eefa845e51a21e9acafdd3e9ec4e4f5c.webp";